import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DayDifferencePipe } from './days-diff.pipe';

@NgModule({
  declarations: [
    DayDifferencePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DayDifferencePipe
  ]
})
export class DaysDiffPipeModule { }
